






































import { Component, Mixins, } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../components/system";
import { IAiKeywordSyntax } from "../../../../../domain/externalSystem";

import { SyntaxEditorMixin } from "./mixins";

@Component
export default class AiSyntaxKeywordEditor extends Mixins(ModelEditableMixin, SyntaxEditorMixin) {
  writePropertyWhenValid: (writer: (source: IAiKeywordSyntax) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IAiKeywordSyntax) => T, defaultValue: T) => T;

  get keyword(): string {
    return this.readPropertyOrDefault(s => s.keyword, null);
  }

  set keyword(value: string) {
    this.writePropertyWhenValid(s => s.keyword = value);
    this.$nextTick(() => this.updateSource());
  }

  get shouldRemoveLineBreak(): boolean {
    return this.readPropertyOrDefault(s => s.shouldRemoveLineBreak, null);
  }

  set shouldRemoveLineBreak(value: boolean) {
    this.writePropertyWhenValid(s => s.shouldRemoveLineBreak = value);
    this.$nextTick(() => this.updateSource());
  }
  get isSupplementEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isSupplementEnable, null);
  }

  set isSupplementEnable(value: boolean) {
    this.writePropertyWhenValid(s => s.isSupplementEnable = value);
    this.$nextTick(() => this.updateSource());
  }

  get supplement(): string {
    return this.readPropertyOrDefault(s => s.supplement, null);
  }

  set supplement(value: string) {
    this.writePropertyWhenValid(s => s.supplement = value);
    this.$nextTick(() => this.updateSource());
  }

  get keywordStyle(): any {
    return {
      backgroundColor: this.shouldInputKeyword ? this.noticeIndicationBackgroundColor : null,

      // IE用の指定
      // placeholderの文字色はCSS変数(--placeholder-color)を使って指定しているがIEでは使えない
      // IEはinputで指定した文字色がplaceholderの文字色になっているため残している
      color: this.shouldInputKeyword ? this.noticeIndicationColor : null,
    };
  }

  get shouldInputKeyword(): boolean {
    return !this.keyword;
  }

  get supplementStyle(): any {
    return {
      backgroundColor: this.shouldInputSupplement ? this.noticeIndicationBackgroundColor : null,

      // IE用の指定
      // placeholderの文字色はCSS変数(--placeholder-color)を使って指定しているがIEでは使えない
      // IEはinputで指定した文字色がplaceholderの文字色になっているため残している
      color: this.shouldInputSupplement ? this.noticeIndicationColor : null,
    };
  }

  get shouldInputSupplement(): boolean {
    return this.isSupplementEnable && !this.supplement;
  }

  createSyntax(): string {
    const keywordArray = this.keyword ? [this.keyword] : [];
    return this.supplementSyntax
      ? this.toSyntax(keywordArray.concat([this.supplementSyntax]), this.shouldRemoveLineBreak)
      : this.toSyntax(keywordArray, this.shouldRemoveLineBreak);
  }

  toSyntax(source: string[], shouldRemoveLineBreak: boolean): string {
    return ["{"]
      .concat(shouldRemoveLineBreak ? [] : ["*"])
      .concat(source)
      .concat(["}"])
      .join(" ");
  }

  get supplementSyntax(): string {
    return this.isSupplementEnable && this.supplement
      ? this.toSyntax([this.supplement], true)
      : "";
  }

  get isSyntaxValid(): boolean {
    return !!this.keyword
      && (!this.isSupplementEnable || (this.isSupplementEnable && !!this.supplement));
  }

  updateSource(): void {
    this.writePropertyWhenValid(s => {
      s.value = this.createSyntax();
      s.isValid = this.isSyntaxValid;
    });
  }
}
